export let poolData = {
	UserPoolId: 'eu-west-1_q2dcHXHpt',
	ClientId: '1tqnn5dhbe90hjm9q4c4fruij8',
};
